var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component } from '@angular/core';
import { Subject } from 'rxjs';
import { ConfigureComponentBase } from '../../../../../shared/configure-component-base';
var ViewSettingsModalComponent = /** @class */ (function (_super) {
    __extends(ViewSettingsModalComponent, _super);
    function ViewSettingsModalComponent(injector, configureViewService, viewTypeService) {
        var _this = _super.call(this, injector) || this;
        _this.configureViewService = configureViewService;
        _this.viewTypeService = viewTypeService;
        _this._onClosed = new Subject();
        return _this;
    }
    Object.defineProperty(ViewSettingsModalComponent.prototype, "configureId", {
        get: function () {
            return this.args.configureId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ViewSettingsModalComponent.prototype, "viewId", {
        get: function () {
            return this.args.viewId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ViewSettingsModalComponent.prototype, "viewType", {
        get: function () {
            return this.data.general.viewType;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ViewSettingsModalComponent.prototype, "viewTypeName", {
        get: function () {
            return this.viewTypeService.getViewTypeDisplayName(this.viewType);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ViewSettingsModalComponent.prototype, "onClosed", {
        get: function () {
            return this._onClosed;
        },
        enumerable: true,
        configurable: true
    });
    ViewSettingsModalComponent.prototype.ngOnInit = function () {
        this.data = this.args.data;
        this.active = !!this.args;
    };
    ViewSettingsModalComponent.prototype.save = function () {
        this.close(this.data);
    };
    ViewSettingsModalComponent.prototype.close = function (modalResult) {
        this._onClosed.next(modalResult);
    };
    ViewSettingsModalComponent.prototype.ngOnDestroy = function () {
        this._onClosed.unsubscribe();
    };
    ViewSettingsModalComponent = __decorate([
        Component({
            selector: 'view-settings-modal',
            template: "<form novalidate (ngSubmit)=\"save()\" bs-modal-drag #viewSttingForm=\"ngForm\" id=\"editViewSettingModal\"> <div *ngIf=\"active\" class=\"fe-modal-container\"> <div class=\"modal-header fe-modal-header\"> <h4 class=\"fe-modal-header-title\"> <span *ngIf=\"viewType === 3\"> <span *ngIf=\"viewId\">{{lc('ModifyViewProperty')}}</span> <span *ngIf=\"!viewId\">{{lc('CreateNewPopView')}}</span> </span> <span *ngIf=\"viewType != 3\"> <span *ngIf=\"viewId\">{{lc('ModifyViewProperty')}}</span> <span *ngIf=\"!viewId\">{{lc('CreateNewView',viewTypeName)}}</span> </span> </h4> <div class=\"fe-modal-header-close\" aria-label=\"Close\" (click)=\"close()\">×</div> </div> <div class=\"top-line\"></div> <div class=\"fe-modal-middle\"> <tabset class=\"tab-container tabbable-line\"> <tab heading=\"{{lc('GeneralProperty')}}\" customClass=\"m-tabs__item\" *ngIf=\"viewType!=2\"> <view-general-setting [data]=\"data.general\"></view-general-setting> </tab> <tab heading=\"{{lc('ViewBackground_TabHead')}}\" customClass=\"m-tabs__item\" *ngIf=\"true\"> <view-background-settings [data]=\"data.background\" [configureId]=\"configureId\"></view-background-settings> </tab> </tabset> </div> <div class=\"fe-modal-footer\"> <div class=\"button-group\"> <button type=\"submit\" class=\"fe-btn fe-btn-default fe-btn-save\" [disabled]=\"!viewSttingForm.form.valid\"> {{l(\"Save\")}} </button> <button type=\"button\" class=\"fe-btn fe-btn-default fe-btn-cancel-one\" (click)=\"close()\"> {{l(\"Cancel\")}} </button> </div> </div> </div> </form>"
        })
    ], ViewSettingsModalComponent);
    return ViewSettingsModalComponent;
}(ConfigureComponentBase));
export { ViewSettingsModalComponent };
